@if (
  status() === 'a_affecter' ||
  status() === 'a_controler' ||
  status() === 'action_backoffice'
) {
  <oui-tag size="big" type="status" status="todo">{{ label() }}</oui-tag>
} @else if (
  status() === 'controle_en_cours' ||
  status() === 'nc_traitee' ||
  status() === 'en_signature' ||
  status() === 'relance' ||
  status() === 'nc_a_traiter' ||
  status() === 'action_consultant' ||
  status() === 'attente_service_externe'
) {
  <oui-tag size="big" type="status" status="transition">{{ label() }}</oui-tag>
} @else if (
  status() === 'affilie' ||
  status() === 'affiliation_en_cours' ||
  status() === 'valide' ||
  status() === 'validation_en_cours'
) {
  <oui-tag size="big" type="status" status="completed">{{ label() }}</oui-tag>
} @else if (status() === 'annule' || status() === 'expire') {
  <oui-tag size="big" type="status" status="pending">{{ label() }}</oui-tag>
} @else if (status() === 'refuse') {
  <oui-tag size="big" type="status" status="error">{{ label() }}</oui-tag>
}
